import React from 'react'

export const SquareIcon = () => <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4 24C4 15.5147 4 11.2721 6.34314 8.63604C8.6863 6 12.4575 6 20 6H28C35.5424 6 39.3138 6 41.6568 8.63604C44 11.2721 44 15.5147 44 24C44 32.4852 44 36.728 41.6568 39.364C39.3138 42 35.5424 42 28 42H20C12.4575 42 8.6863 42 6.34314 39.364C4 36.728 4 32.4852 4 24Z" stroke="#D25D3E" strokeWidth="2.4" />
  <path d="M4 18H20C25.6568 18 28.4852 18 30.2426 19.7574C32 21.5148 32 24.3432 32 30V42" stroke="#D25D3E" strokeWidth="2.4" />
  <path d="M20 42V18" stroke="#D25D3E" strokeWidth="2.4" />
</svg>
